import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { Content } from './components/Content';
import { Menu } from './components/Menu';
import { PricingServices } from './pages/PricingServices';
import { SEO } from './components/SEO';
export function App() {
  return <Router data-id="element-0">
      <SEO data-id="element-1" />
      <div className="min-h-screen bg-white font-body text-gray-800" data-id="element-2">
        <Navigation data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<>
                <SEO title="Fight Club Med Spa Phoenix, Arizona | Premier Medical Aesthetics" description="Fight Club Med Spa offers premium medical aesthetics services in Phoenix, Arizona. Specializing in Botox, fillers, PDO threads, and more with a traveling concierge option." pathname="/" data-id="element-6" />
                <Hero data-id="element-7" />
                <Content data-id="element-8" />
              </>} data-id="element-5" />
          <Route path="/menu" element={<>
                <SEO title="Services Menu | Fight Club Med Spa Phoenix, Arizona" description="Explore our comprehensive menu of medical aesthetics services including neuromodulators, fillers, PDO threads, and microneedling at Fight Club Med Spa in Phoenix." pathname="/menu" data-id="element-10" />
                <Menu data-id="element-11" />
              </>} data-id="element-9" />
          <Route path="/services" element={<>
                <SEO title="Pricing & Services | Fight Club Med Spa Phoenix, Arizona" description="View our detailed pricing and services for medical aesthetics treatments including Botox, fillers, PDO threads, and more at Fight Club Med Spa in Phoenix." pathname="/services" data-id="element-13" />
                <PricingServices data-id="element-14" />
              </>} data-id="element-12" />
        </Routes>
        <Footer data-id="element-15" />
      </div>
    </Router>;
}